module.exports = {" _key":"@dojo/widgets/three-column-layout","root":"three-column-layout-m__root__31HFf","center":"three-column-layout-m__center__3u6bV"};